<div class="w-100">
    <mwp-card-content-header [url]="apiUrl" />
    @if(isLoaded){
    <div class="row">
        <div class="col-3">
            <mwp-dashboard-boxes [labelOne]="boxOneLabel" [labelTwo]="boxTwoLabel" [amountOne]="boxOneValue" [amountTwo]="boxTwoValue" />
            <div class="col-12">
                <mwp-current-deductions [currentBenefits]="currentBenefits" />
            </div>
        </div>
        <div class="col-3">
            <mwp-paycheck-details [dashboardPayCheckModel]="dashboardPayCheckModel" />
        </div>
        <div class="col-6">
            <mwp-profile-info [member]="member" />
        </div>
    </div>
    }
</div>